const MuiTipography = {
  gutterBottom: {
    marginBottom: 8
  }
};
export default MuiTipography;